import styled, { css } from 'styled-components';

interface StateProps {
  done?: boolean;
  current?: boolean;
}

export const Container = styled.div`
  width: 100%;
  height: auto;
  min-width: 0;

  ol {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    list-style: none;
    min-width: 0;
  }
`;

export const StepItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-width: 0;

  /* Nenhum item estica: a trilha fica compacta à esquerda, senão um fluxo de
     duas etapas viraria uma linha atravessando a tela toda. */
  flex: 0 1 auto;
`;

export const Connector = styled.span<StateProps>`
  flex: 0 1 auto;
  width: 5rem;
  min-width: 1rem;
  height: 1px;
  background: ${props => (props.done ? 'var(--primary)' : 'var(--border)')};
  transition: background-color 0.25s;
`;

export const Bullet = styled.span<StateProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 700;
  border: 1px solid var(--stone-300);
  background: rgba(255, 255, 255, 0.85);
  color: var(--stone-400);
  transition: background-color 0.25s, border-color 0.25s, color 0.25s,
    box-shadow 0.25s;

  ${props =>
    (props.done || props.current) &&
    css`
      border-color: var(--primary);
      background: var(--primary);
      color: var(--primary-foreground);
    `}

  ${props =>
    props.current &&
    css`
      box-shadow: 0 0 0 3px rgba(255, 188, 3, 0.3);
    `}
`;

export const Label = styled.span<StateProps>`
  font-size: 0.8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${props => (props.current ? 700 : 400)};
  color: ${props => {
    if (props.current) return 'var(--foreground)';
    if (props.done) return 'var(--stone-500)';
    return 'var(--stone-400)';
  }};

  @media (max-width: 900px) {
    display: none;
  }
`;
